/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'
import styled from 'styled-components'
import i18next from 'I18n'
import { Menu } from 'antd'
import { useTranslation } from 'react-i18next'

import { EN_ICON, HAMBURGER_MENU, JP_ICON, VI_ICON } from 'Assets'
import { useAuth, useRoot } from 'Hooks'
import { Link } from 'react-router-dom'

const Wrapper = styled.header`
  padding: 0 81px;
  width: 100%;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  position: fixed;
  z-index: 1000;

  .ant-popover.ant-popover-placement-bottom {
    position : fixed;
  }
  .toggle-menu {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    margin-right: 4px;

    button {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      outline: none;
      color: #374151;
      padding: 0;
      min-width: 40px;
      min-height: 40px;
    }

    button svg,
    button svg * {
      stroke: #374151;
      fill: #374151;
    }
  }

  .header-brand img {
    display: block;
    height: 32px;
    width: auto;
    max-width: 220px;
    object-fit: contain;
  }

  .container {
    height: 63px;
    width: 100%;

    .row {
      height: 100%;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-start;
      width: 100%;

      .header-left {
        flex: 1 0;

        .search {
          display: flex;
          align-items: center;

          label.cursor-pointer {
            cursor: pointer;

            svg.svg-icon--material {
              font-size: 1.5rem;
              fill: #374151;
            }
          }

          input.search-input {
            border: none;
            background-color: transparent;
            width: 100%;
            font-weight: 500;
            padding: .3rem .75rem;

            &:focus-visible {
              outline: none;
            }
          }
        }

        .logo {
          width: 150px;
        }
      }

      .header-right {
        flex: 0 0 auto;
        width: auto;

        .row {
          flex-wrap: wrap;

          .col-auto {
            margin: .5rem;

            button {
              cursor: pointer;
            }
          }

          .btn-action {
            padding: .625rem;
            width: calc(28px + 1.25rem);
            height: calc(28px + 1.25rem);
            background-color: transparent;
            border: none;
            border-radius: 1.25rem;

            &:hover, &:active {
              background-color: #f3f4f6;
              border-color: #e5e7eb;
            }
          }
        }
      }
    }
  }
`

const useLocalStorage = import.meta.env.VITE_USE_LOCAL_STORAGE === 'true'
const localUrl = typeof window !== 'undefined' ? window.location.origin : ''

const Header = () => {
  const { t, i18n: { language } } = useTranslation(['menu'])
  const { authenticated } = useAuth()
  const { toggleSidebarAction } = useRoot()

  const languageIcon = useMemo(() => {
    switch (language) {
      case 'en':
        return <EN_ICON />
      case 'jp':
        return <JP_ICON />
      case 'vi':
        return <VI_ICON />
      default:
        return null
    }
  }, [language])

  const menu = (
    <Menu>
      <Menu.Item key="0" onClick={() => i18next.changeLanguage('en')}>
        <EN_ICON />
        <span>&nbsp;English</span>
      </Menu.Item>
      <Menu.Item key="1" onClick={() => i18next.changeLanguage('jp')}>
        <JP_ICON />
        <span>&nbsp;日本語</span>
      </Menu.Item>
      <Menu.Item key="2" onClick={() => i18next.changeLanguage('vi')}>
        <VI_ICON />
        <span>&nbsp;Tiếng Việt</span>
      </Menu.Item>
    </Menu>
  )

  function handleToggleSidebar() {
    toggleSidebarAction()
  }

  return (
    <Wrapper>
      <div className="container">
        <div className="row">
          {
            authenticated && (
              <div className="toggle-menu">
                <button type="button" onClick={() => handleToggleSidebar()}>
                  <HAMBURGER_MENU />
                </button>
              </div>
            )
          }
          <Link
            to="/"
            className="header-brand"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              flex: '0 0 auto'
            }}
          >
            <img src="/hitseries-logo.png" alt="HITSERIES" />
          </Link>

          {useLocalStorage && localUrl && (
            <a
              href={localUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                marginLeft: 16,
                fontSize: 12,
                color: '#6b7280',
                textDecoration: 'none'
              }}
            >
              {localUrl}
            </a>
          )}

        </div>
      </div>
    </Wrapper>
  )
}

export default Header
